import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function PaymentError() {
  const location = useLocation();
  const [errorMessage, setErrorMessage] = useState('');
  const [orderInfo, setOrderInfo] = useState<any>(null);

  useEffect(() => {
    // Intentar obtener el mensaje de error de la URL si existe
    const params = new URLSearchParams(location.search);
    const errorParam = params.get('error');
    if (errorParam) {
      setErrorMessage(decodeURIComponent(errorParam));
    }

    // Intentar recuperar la información del pedido del localStorage
    const pendingOrder = localStorage.getItem('pendingOrder');
    if (pendingOrder) {
      try {
        const parsedOrder = JSON.parse(pendingOrder);
        setOrderInfo(parsedOrder);
      } catch (e) {
        // Error al parsear el pedido pendiente
      }
    }
  }, [location]);

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{backgroundImage: 'url(/background.jpg)', backgroundSize: 'cover', backgroundPosition: 'center', backgroundAttachment: 'fixed'}}>
      <div className="bg-white rounded-lg shadow-lg max-w-md w-full p-8 text-center animate-fade-in border border-gray-200">
        {/* Icono de error */}
        <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6 border-4 border-red-200">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </div>
        
        {/* Título y descripción */}
        <h1 className="text-3xl font-bold text-red-600 mb-3">Error en el Pago</h1>
        <p className="text-gray-600 mb-8 max-w-xs mx-auto">
          {errorMessage || 'Ha ocurrido un error al procesar tu pago. No te preocupes, no se ha realizado ningún cargo a tu cuenta.'}
        </p>
        
        {/* Detalles del pedido */}
        {orderInfo && (
          <div className="bg-gray-50 p-6 rounded-lg mb-8 text-left border border-gray-200 shadow-sm">
            <h2 className="font-bold text-lg mb-4 border-b border-gray-200 pb-3 text-gray-800">Detalles del pedido</h2>
            
            <div className="space-y-3">
              {orderInfo.garment_name && (
                <div className="flex justify-between">
                  <span className="font-medium text-gray-700">Prenda:</span>
                  <span className="text-gray-900">{orderInfo.garment_name}</span>
                </div>
              )}
              
              {orderInfo.color_name && (
                <div className="flex justify-between">
                  <span className="font-medium text-gray-700">Color:</span>
                  <span className="text-gray-900">{orderInfo.color_name}</span>
                </div>
              )}
              
              {orderInfo.size_name && (
                <div className="flex justify-between">
                  <span className="font-medium text-gray-700">Talla:</span>
                  <span className="text-gray-900">{orderInfo.size_name}</span>
                </div>
              )}
            </div>
            
            <div className="mt-6 pt-4 border-t border-gray-200">
              <div className="flex justify-between items-center">
                <span className="font-bold text-gray-800">Total:</span>
                <span className="font-bold text-xl text-red-600">{orderInfo.total_price.toFixed(2)}€</span>
              </div>
            </div>
          </div>
        )}
        
        {/* Botón de inicio */}
        <Link 
          to="/"
          className="w-full px-4 py-3.5 bg-[#F90000] text-white rounded-md font-medium hover:bg-[#D80000] transition-colors flex items-center justify-center space-x-2"
        >
          <span>Volver al inicio</span>
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
          </svg>
        </Link>
      </div>
    </div>
  );
} 